import { useState, useEffect } from "react";
import axios from "axios";

export const instanceAxios = axios.create({
  baseURL: process.env.REACT_APP_API_CMP_URL,
  timeout: 60000,
});

const useApiCmp = (url) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    instanceAxios
      .get(url)
      .then((response) => {
        setIsLoading(false);
        setData(response.data);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [url]);

  return { isLoading, isError, data };
};

export default useApiCmp;
